import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Layout from "../components/layout"
import "../styles/people.scss"
import Img from "gatsby-image"
import {Carousel} from "react-bootstrap";

const People = () => {
  const data = useStaticQuery(graphql`
          query {
              filepostdoc_1: file(relativePath: {eq: "images/members/postdoc_1.jpg"}) {
                    childImageSharp {
                      fixed(width: 280) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                }
                filepostdoc_2: file(relativePath: {eq: "images/members/postdoc_2.jpg"}) {
                      childImageSharp {
                        fixed(width: 280) {
                          ...GatsbyImageSharpFixed
                        }
                      }
                  }
              filephd_1: file(relativePath: {eq: "images/members/phd_1.jpg"}) {
                    childImageSharp {
                      fixed(width: 280) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                }
              filephd_2: file(relativePath: {eq: "images/members/phd_2.jpg"}) {
                      childImageSharp {
                        fixed(width: 280) {
                          ...GatsbyImageSharpFixed
                        }
                    }
                }
                filephd_3: file(relativePath: {eq: "images/members/phd_3.JPG"}) {
                        childImageSharp {
                          fixed(width: 280) {
                            ...GatsbyImageSharpFixed
                          }
                      }
                  }
                  filephd_4: file(relativePath: {eq: "images/members/phd_4.jpg"}) {
                          childImageSharp {
                            fixed(width: 280) {
                              ...GatsbyImageSharpFixed
                            }
                        }
                    }
                    filephd_5: file(relativePath: {eq: "images/members/phd_5.jpg"}) {
                            childImageSharp {
                              fixed(width: 280) {
                                ...GatsbyImageSharpFixed
                              }
                          }
                      }
                      filephd_6: file(relativePath: {eq: "images/members/phd_6.JPG"}) {
                              childImageSharp {
                                fixed(width: 280) {
                                  ...GatsbyImageSharpFixed
                                }
                            }
                        }
                        filephd_7: file(relativePath: {eq: "images/members/phd_7.jpg"}) {
                                childImageSharp {
                                  fixed(width: 280) {
                                    ...GatsbyImageSharpFixed
                                  }
                              }
                          }
                          filephd_8: file(relativePath: {eq: "images/members/phd_8.jpg"}) {
                                  childImageSharp {
                                    fixed(width: 280) {
                                      ...GatsbyImageSharpFixed
                                    }
                                }
                            }
                            filephd_9: file(relativePath: {eq: "images/members/phd_9.jpg"}) {
                                    childImageSharp {
                                      fixed(width: 280) {
                                        ...GatsbyImageSharpFixed
                                      }
                                  }
                              }
                              filephd_10: file(relativePath: {eq: "images/members/phd_10.jpg"}) {
                                      childImageSharp {
                                        fixed(width: 280) {
                                          ...GatsbyImageSharpFixed
                                        }
                                    }
                                }
                        filemsc_1: file(relativePath: {eq: "images/members/msc_1.jpg"}) {
                              childImageSharp {
                                fixed(width: 280) {
                                  ...GatsbyImageSharpFixed
                                }
                              }
                          }
                          filemsc_2: file(relativePath: {eq: "images/members/msc_2.jpg"}) {
                                childImageSharp {
                                  fixed(width: 280) {
                                    ...GatsbyImageSharpFixed
                                  }
                                }
                            }
                          filemsc_3: file(relativePath: {eq: "images/members/msc_3.jpg"}) {
                                  childImageSharp {
                                    fixed(width: 280) {
                                      ...GatsbyImageSharpFixed
                                    }
                                }
                            }
                            filemsc_4: file(relativePath: {eq: "images/members/msc_4.jpg"}) {
                                    childImageSharp {
                                      fixed(width: 280) {
                                        ...GatsbyImageSharpFixed
                                      }
                                  }
                              }
                              filemsc_5: file(relativePath: {eq: "images/members/msc_5.JPG"}) {
                                      childImageSharp {
                                        fixed(width: 280) {
                                          ...GatsbyImageSharpFixed
                                        }
                                    }
                                }
                                filemsc_6: file(relativePath: {eq: "images/members/msc_6.jpg"}) {
                                        childImageSharp {
                                          fixed(width: 280) {
                                            ...GatsbyImageSharpFixed
                                          }
                                      }
                                  }
                                  filemsc_7: file(relativePath: {eq: "images/members/msc_7.jpg"}) {
                                          childImageSharp {
                                            fixed(width: 280) {
                                              ...GatsbyImageSharpFixed
                                            }
                                        }
                                    }
                                    filemsc_8: file(relativePath: {eq: "images/members/msc_8.jpg"}) {
                                            childImageSharp {
                                              fixed(width: 280) {
                                                ...GatsbyImageSharpFixed
                                              }
                                          }
                                      }
                                      filemsc_9: file(relativePath: {eq: "images/members/msc_9.jpg"}) {
                                              childImageSharp {
                                                fixed(width: 280) {
                                                  ...GatsbyImageSharpFixed
                                                }
                                            }
                                        }
                                      filemsc_10: file(relativePath: {eq: "images/members/msc_10.jpg"}) {
                                                childImageSharp {
                                                  fixed(width: 280) {
                                                    ...GatsbyImageSharpFixed
                                                  }
                                              }
                                          }
          }
      `)


  return(
    <Layout>
    <div className="people">

        <h1>ANRF Project Researcher</h1>

          <div class="container">
          <div class="row">
          <div class="col-sm">
          <Img className="Member_5" fixed={data.filepostdoc_2.childImageSharp.fixed}></Img>
          </div>
          <div class="col-sm">
          <div className= "Phd1_data">
          <h3>Dr. Sandeepan Maity
          <small class="text-muted"> (ANRF)</small></h3>
          <p></p>
          <p>Assoc. Professor (C. V. Raman Global University)</p>
          <p>Homeplace: Sagar Krishnanagar, Sagar, South 24 Parganas, West Bengal</p>
          <p> Research field: Photochemistry and SmI2 Catalysis</p>
          <p><a href="mailto: maitysandeepan2017@gmail.com"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
          <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
          </svg>&nbsp;maitysandeepan2017@gmail.com</a>&emsp;</p>
          </div>
          </div>
          </div>
          </div>

          <div className="Liner"></div>
          <pre></pre>

        <h1>Post-Doc Researcher</h1>

        <div class="container">
        <div class="row">
        <div class="col-sm">
        <Img className="Member_5" fixed={data.filepostdoc_1.childImageSharp.fixed}></Img>
        </div>
        <div class="col-sm">
        <div className= "Phd1_data">
        <h3>Dr. Suchismita Rath
        <small class="text-muted"> (RA)</small></h3>
        <p></p>
        <p>PhD-2024 (SNIoE)</p>
        <p>Homeplace: Bolgarh, Khordha, Odisha</p>
        <p> Research field: Photochemistry</p>
        <p><a href="mailto: rathsuchismita52@gmail.com"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
        <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
        </svg>&nbsp;rathsuchismita52@gmail.com</a>&emsp;</p>
        </div>
        </div>
        </div>
        </div>

        <div className="Liner"></div>
        <pre></pre>

<h1> PhD Researchers</h1>


<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filephd_10.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Pravat Nayek
<small class="text-muted"> (SRF)</small></h3>
<p>B.Sc-2019 (Midnapore college autonomous), M.Sc.-2021 (IIEST, Shibpur)</p>
<p> Qualified Gate 2021 / CSIR Net 2021 June (UGC fellowship)</p>
<p>Joined this group in August-2022</p>
<p>Homeplace: Moyna, West Bengal</p>
<p>Research field: Metal-free oxidation</p>
<p><a href="mailto: pravat.nayek@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;pravat.nayek@niser.ac.in</a></p>
</div>
</div>
</div>
</div>
<pre></pre>



<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filephd_8.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Sathi Sahoo
<small class="text-muted"> (SRF)</small></h3>
<p>B.Sc-2019 (Midnapore college autonomous), M.Sc.-2021 (Vidyasagar University, WB)</p>
<p> Qualified GATE 2021</p>
<p>Joined this group in August-2022</p>
<p>Homeplace: Egra, West Bengal</p>
<p>Research field: Photo-mediated radical chemistry</p>
<p><a href="mailto: sathi.sahoo@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;sathi.sahoo@niser.ac.in</a></p>
</div>
</div>
</div>
</div>
<pre></pre>


<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filephd_2.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Chidananda Biswal
<small class="text-muted"> (JRF)</small></h3>
<p>B.Sc-2021 (Govt. (Auto) College, Angul), M.Sc.-2023 (Veer Surendra Sai University of Technology, OD)</p>
<p> Qualified CSIR-UGC NET 2023</p>
<p>Joined this group in August-2024</p>
<p>Homeplace: Angul, Odisha</p>
<p>Research field: Ball Milling Reactions</p>
<p><a href="mailto: chidananda.biswal@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;chidananda.biswal@niser.ac.in</a></p>
</div>
</div>
</div>
</div>
<pre></pre>

<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filephd_3.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Ramen Guchait
<small class="text-muted"> (JRF)</small></h3>
<p>B.Sc-2019 (Amta Ramsaday college, WB), M.Sc.-2021 (University of North Bengal, WB)</p>
<p> Qualified CSIR-UGC NET 2023</p>
<p>Joined this group in January-2025</p>
<p>Homeplace: Udaynarayanpur, West Bengal</p>
<p>Research field: Photochemistry and Electro-organic synthesis</p>
<p><a href="mailto: ramendranath.guchait@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;ramendranath.guchait@niser.ac.in</a></p>
</div>
</div>
</div>
</div>
<pre></pre>

<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filephd_4.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Lipika Bardhan
<small class="text-muted"> (JRF)</small></h3>
<p>B.Sc-2021 (KKS Women's College, WB), M.Sc.-2022 (NISER Bhubaneswar, Odisha)</p>
<p> Qualified CSIR-UGC NET 2024</p>
<p>Joined this group in August 2024</p>
<p>Homeplace: Balasore, Odisha</p>
<p>Research field: Photocatalysis & Mechanochemistry</p>
<p><a href="mailto: lipika.bardhan@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;lipika.bardhan@niser.ac.in</a></p>
</div>
</div>
</div>
</div>
<pre></pre> 

<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filephd_1.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Mamata Mallick
<small class="text-muted"> (JRF)</small></h3>
<p>B.Sc-2021 (FM University, Odisha), M.Sc.-2024 (FM University, Odisha)</p>
<p> Qualified CSIR-NET 2024</p>
<p>Joined this group in January 2026</p>
<p>Homeplace: Bhadrak, Odisha</p>
<p>Research field: Photocatalysis & Mechanochemistry</p>
<p><a href="mailto: mamata.mallick@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp; mamata.mallick@niser.ac.in</a></p>
</div>
</div>
</div>
</div>
<pre></pre>   

<div className="Liner"></div>
<pre></pre>

<h1> Int. PhD Researcher</h1>


<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_9.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Suman Handal
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2025</p>
<p>Currently continuing Int. PhD (NISER), 6th semester</p>
<p> Qualified IIT JAM 2023</p>
<p>Hometown: Ghatal, West Bengal</p>
<p>Research field: Photocatalysis</p>
<p><a href="mailto: Suman.Handal@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;Suman.Handal@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre>  


<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_3.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Suman Kalyan Bishal 
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2026</p>
<p>Currently continuing Int. PhD (NISER), 5th semester</p>
<p> Qualified IIT JAM 2024</p>
<p>Hometown: Kirtankhali, West Bengal</p>
<p>Research field: Photoredox catalysis</p>
<p><a href="mailto: sumankalyan.bishal@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;sumankalyan.bishal@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre>  

<div className="Liner"></div>
<pre></pre>

<h1> M.Sc. Researchers</h1>



 

  
<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_6.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Sonali Priyadarshini Swain
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2025</p>
<p>Currently continuing Int. MSc (NISER), 8th semester</p>
<p> Qualified NEST Exam, 2022</p>
<p>Hometown: Puri, Odisha</p>
<p>Research field: Organo-photocatalysis</p>
<p><a href="mailto: sonali.swain@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;sonali.swain@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre>
  
 
<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_2.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Megha Pradhan
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2025</p>
<p>Currently continuing Int. MSc (NISER), 8th semester</p>
<p> Qualified NEST Exam, 2022</p>
<p>Hometown: Rourkela, Odisha</p>
<p>Research field: Organometallic chemistry in organic synthesis</p>
<p><a href="mailto: megha.pradhan@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;megha.pradhan@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre>  
 
  
<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_4.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Ashish Mishra
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2025</p>
<p>Currently continuing Int. MSc (NISER), 8th semester</p>
<p> Qualified NEST Exam, 2022</p>
<p>Hometown: Dhenkanal, Odisha</p>
<p>Research field: Organocatalysis</p>
<p><a href="mailto: ashishmishra.2022@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;ashishmishra.2022@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre>  
  

<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_1.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Rajdeep Bhowmick 
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2026</p>
<p>Currently continuing Int. MSc (NISER), 7th semester</p>
<p> Qualified NEST Exam, 2022</p>
<p>Hometown: Kolkata, West Bengal </p>
<p>Research field: Photocatalysis</p>
<p><a href="rajdeep.bhowmick@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;rajdeep.bhowmick@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre> 



<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_10.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Anindita Mondal
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2026</p>
<p>Currently continuing Int. MSc (NISER), 7th semester</p>
<p> Qualified NEST Exam, 2023</p>
<p>Hometown: Ranaghat, West Bengal </p>
<p>Research field: Organometallic Hydrogenation</p>
<p><a href="anindita.mondal@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;anindita.mondal@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre> 


<div class="container">
<div class="row">
<div class="col-sm">
<Img className="Member_5" fixed={data.filemsc_7.childImageSharp.fixed}></Img>
</div>
<div class="col-sm">
<div className= "Phd1_data">
<h3>Soumyabrata De
<p><small class="text-muted"></small></p></h3>
<p>Joined this group in August 2026</p>
<p>Currently continuing Int. MSc (NISER), 7th semester</p>
<p> Qualified NEST Exam, 2023</p>
<p>Hometown: Coochbehar , west bengal </p>
<p>Research field: Photocatalysis</p>
<p><a href="soumyabrata.de@niser.ac.in"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
<path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
</svg>&nbsp;soumyabrata.de@niser.ac.in</a>&emsp;</p>
</div>
</div>
</div>
</div>
<pre></pre>

  
</div>
</Layout>
  )
}

export default People
